// extracted by mini-css-extract-plugin
export default {"wrapper":"draw-unavailable_wrapper"};